var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
// SPDX-FileCopyrightText: 2025 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { useContext, useEffect, useMemo, useState } from "react";
import { useAtom } from "jotai";
import archivedElectionEventSelection from "@/atoms/archived-election-event-selection";
import { useLocation, useNavigate } from "react-router-dom";
import { styled } from "@mui/material/styles";
import { IconButton, adminTheme } from "@sequentech/ui-essentials";
import { translateFromPresentation, } from "@sequentech/ui-core";
import SearchIcon from "@mui/icons-material/Search";
import { Button, Box, CircularProgress, TextField, MenuItem as MMenuItem, Menu as MMenu, } from "@mui/material";
import { Menu, useGetOne, useSidebarState } from "react-admin";
import { TreeMenu } from "./election-events/TreeMenu";
import { faPlusCircle } from "@fortawesome/free-solid-svg-icons";
import WebIcon from "@mui/icons-material/Web";
import { HorizontalBox } from "../../HorizontalBox";
import { useTenantStore } from "@/providers/TenantContextProvider";
import { AuthContext } from "@/providers/AuthContextProvider";
import { useTranslation } from "react-i18next";
import { IPermissions } from "../../../types/keycloak";
import { useTreeMenuData } from "./use-tree-menu-hook";
import { cloneDeep, debounce } from "lodash";
import { useUrlParams } from "@/hooks/useUrlParams";
import { useCreateElectionEventStore } from "@/providers/CreateElectionEventContextProvider";
import { useLazyQuery } from "@apollo/client";
import { FETCH_CANDIDATE_TREE, FETCH_CONTEST_TREE, FETCH_ELECTIONS_TREE, } from "@/queries/GetElectionEventsTree";
import { useElectionEventTallyStore } from "@/providers/ElectionEventTallyProvider";
import { sortCandidatesInContest, sortContestList, sortElectionList } from "@sequentech/ui-core";
import { useAliasRenderer } from "@/hooks/useAliasRenderer";
var MenuItem = styled(Menu.Item)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    color: ", ";\n\n    &.RaMenuItemLink-active,\n    .MuiIconButton-root {\n        color: ", ";\n    }\n"], ["\n    color: ", ";\n\n    &.RaMenuItemLink-active,\n    .MuiIconButton-root {\n        color: ", ";\n    }\n"])), adminTheme.palette.brandColor, adminTheme.palette.brandColor);
var StyledIconButton = styled(IconButton)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    &:hover {\n        padding: unset !important;\n    }\n    font-size: 1rem;\n    line-height: 1.5rem;\n"], ["\n    &:hover {\n        padding: unset !important;\n    }\n    font-size: 1rem;\n    line-height: 1.5rem;\n"])));
var StyledButton = styled(Button)(function (_a) {
    var theme = _a.theme;
    return ({
        "backgroundColor": "white",
        "color": theme.palette.brandColor,
        "border": "none",
        "boxShadow": "none",
        "&:hover": {
            color: theme.palette.brandColor,
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            boxShadow: "none",
        },
        "&:active": {
            color: theme.palette.brandColor,
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            border: "none",
            boxShadow: "none",
        },
        "&:focus": {
            color: theme.palette.brandColor,
            backgroundColor: "rgba(0, 0, 0, 0.04)",
            border: "none",
            boxShadow: "none",
        },
    });
});
var Container = styled("div")(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background-color: ", ";\n"], ["\n    background-color: ", ";\n"])), function (_a) {
    var isActive = _a.isActive;
    return (isActive ? adminTheme.palette.green.light : "initial");
});
var SideBarContainer = styled("div")(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    display: flex;\n    align-items: center;\n    background-color: white;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    & > *:not(:last-child) {\n        margin-right: 1rem;\n    }\n"], ["\n    display: flex;\n    align-items: center;\n    background-color: white;\n    padding-left: 1rem;\n    padding-right: 1rem;\n    & > *:not(:last-child) {\n        margin-right: 1rem;\n    }\n"])));
export function mapDataChildren(key) {
    var map = {
        sequent_backend_election_event: "electionEvents",
        sequent_backend_election: "elections",
        sequent_backend_contest: "contests",
        sequent_backend_candidate: "candidates",
    };
    return map[key];
}
export var TREE_RESOURCE_NAMES = [
    "sequent_backend_election_event",
    "sequent_backend_election",
    "sequent_backend_contest",
    "sequent_backend_candidate",
];
var ENTITY_FIELD_NAMES = [
    "electionEvents",
    "elections",
    "contests",
    "candidates",
];
function filterTree(tree, filterName) {
    var _a, _b;
    if (Array.isArray(tree)) {
        return tree.map(function (subTree) { return filterTree(subTree, filterName); }).filter(function (v) { return v !== null; });
    }
    else if (typeof tree === "object" && tree !== null) {
        for (var key in tree) {
            if (((_a = tree.name) === null || _a === void 0 ? void 0 : _a.toLowerCase().search(filterName.toLowerCase())) > -1 ||
                ((_b = tree.alias) === null || _b === void 0 ? void 0 : _b.toLowerCase().search(filterName.toLowerCase())) > -1) {
                return tree;
            }
            else if (ENTITY_FIELD_NAMES.includes(key)) {
                var filteredSubTree = filterTree(tree[key], filterName);
                if (filteredSubTree.length > 0) {
                    var filteredObj = __assign({}, tree);
                    filteredObj[key] = filteredSubTree;
                    return filteredObj;
                }
            }
        }
    }
    return null;
}
export default function ElectionEvents() {
    var _a;
    var tenantId = useTenantStore()[0];
    var isOpenSidebar = useSidebarState()[0];
    var _b = useState(""), instantSearchInput = _b[0], setInstantSearchInput = _b[1];
    var _c = useState(""), searchInput = _c[0], setSearchInput = _c[1];
    var navigate = useNavigate();
    var aliasRenderer = useAliasRenderer();
    var _d = useAtom(archivedElectionEventSelection), isArchivedElectionEvents = _d[0], setArchivedElectionEvents = _d[1];
    var _e = useCreateElectionEventStore(), openCreateDrawer = _e.openCreateDrawer, openImportDrawer = _e.openImportDrawer;
    var _f = useUrlParams(), election_event_id = _f.election_event_id, election_id = _f.election_id, contest_id = _f.contest_id, candidate_id = _f.candidate_id;
    var _g = useState(null), anchorEl = _g[0], setAnchorEl = _g[1];
    var _h = useTreeMenuData(isArchivedElectionEvents), data = _h.data, loading = _h.loading, originalRefetch = _h.refetch;
    var authContext = useContext(AuthContext);
    var showAddElectionEvent = authContext.isAuthorized(true, tenantId, IPermissions.ELECTION_EVENT_CREATE);
    var _j = useTranslation(), t = _j.t, i18n = _j.i18n;
    var _k = useState(""), electionEventId = _k[0], setElectionEventId = _k[1];
    var _l = useState(""), electionId = _l[0], setElectionId = _l[1];
    var _m = useState(""), contestId = _m[0], setContestId = _m[1];
    var _o = useState(""), candidateId = _o[0], setCandidateId = _o[1];
    var getCandidateIdFlag = useElectionEventTallyStore().getCandidateIdFlag;
    /**
     * Hooks to load data for entities
     */
    var _p = useGetOne("sequent_backend_election_event", { id: election_event_id }, {
        enabled: !!election_event_id,
        onSuccess: function (data) {
            setElectionEventId(data.id);
            setElectionId("");
            setContestId("");
            setCandidateId("");
        },
    }), electionEventData = _p.data, electionEventDataRefetch = _p.refetch;
    var refetchElectionData = useGetOne("sequent_backend_election", { id: election_id }, {
        enabled: !!election_id,
        onSuccess: function (data) {
            setElectionEventId(data.election_event_id);
            setElectionId(data.id);
            setContestId("");
            setCandidateId("");
        },
    }).refetch;
    var refetchContestData = useGetOne("sequent_backend_contest", { id: contest_id || contestId }, {
        enabled: !!contest_id,
        onSuccess: function (data) {
            setElectionId(data.election_id);
            setElectionEventId(data.election_event_id);
            setContestId(data.id);
            setCandidateId("");
        },
    }).refetch;
    var candidateData = useGetOne("sequent_backend_candidate", { id: candidate_id }, {
        enabled: !!candidate_id,
        onSuccess: function (data) {
            setContestId(data.contest_id);
            setElectionEventId(data.election_event_id);
            setCandidateId(data.id);
        },
    }).refetch;
    var _q = useLazyQuery(FETCH_ELECTIONS_TREE), getElectionTree = _q[0], _r = _q[1], electionTreeData = _r.data, _electionTreeRefetch = _r.refetch;
    var _s = useLazyQuery(FETCH_CONTEST_TREE), getContestTree = _s[0], _t = _s[1], contestTreeData = _t.data, _contestTreeRefetch = _t.refetch;
    var _u = useLazyQuery(FETCH_CANDIDATE_TREE), getCandidateTree = _u[0], _v = _u[1], candidateTreeData = _v.data, _candidateTreeRefetch = _v.refetch;
    // Wrapper refetch functions: only call the internal refetch if variables
    // are set
    var electionEventTreeRefetch = function () {
        if (tenantId) {
            originalRefetch({
                tenantId: tenantId,
                isArchived: isArchivedElectionEvents,
            });
        }
    };
    var electionTreeRefetch = function () {
        if (tenantId && electionEventId) {
            _electionTreeRefetch({
                variables: {
                    tenantId: tenantId,
                    electionEventId: electionEventId,
                },
            });
        }
    };
    var contestTreeRefetch = function () {
        if (tenantId && electionId) {
            _contestTreeRefetch({
                variables: {
                    tenantId: tenantId,
                    electionId: electionId,
                },
            });
        }
    };
    var candidateTreeRefetch = function () {
        if (tenantId && contestId) {
            _candidateTreeRefetch({
                variables: {
                    tenantId: tenantId,
                    contestId: contestId,
                },
            });
        }
    };
    // Instead of setting variables in the options, we now call the lazy queries
    // only when variables exist.
    // Force reload election event data when tenant ID changes or component mounts
    useEffect(function () {
        if (tenantId) {
            originalRefetch({
                tenantId: tenantId,
                isArchived: isArchivedElectionEvents,
            });
        }
    }, [tenantId, isArchivedElectionEvents, originalRefetch]);
    useEffect(function () {
        if (tenantId && electionEventId) {
            getElectionTree({
                variables: {
                    tenantId: tenantId,
                    electionEventId: electionEventId,
                },
            });
        }
    }, [tenantId, electionEventId, getElectionTree]);
    useEffect(function () {
        if (tenantId && electionId) {
            getContestTree({
                variables: {
                    tenantId: tenantId,
                    electionId: electionId,
                },
            });
        }
    }, [tenantId, electionId, getContestTree]);
    useEffect(function () {
        if (tenantId && contestId) {
            getCandidateTree({
                variables: {
                    tenantId: tenantId,
                    contestId: contestId,
                },
            });
        }
    }, [tenantId, contestId, candidateId, getCandidateTree]);
    var location = useLocation();
    var isElectionEventActive = TREE_RESOURCE_NAMES.some(function (route) { return location.pathname.search(route) > -1; });
    useEffect(function () {
        var callerPath = location.pathname.split("/")[1];
        if (callerPath === "sequent_backend_election") {
            electionTreeRefetch();
            refetchElectionData();
        }
        else if (callerPath === "sequent_backend_contest") {
            contestTreeRefetch();
            refetchContestData();
        }
        else if (callerPath === "sequent_backend_candidate") {
            candidateData();
            candidateTreeRefetch();
        }
        else if (callerPath === "sequent_backend_election_event") {
            electionEventTreeRefetch();
            electionEventDataRefetch();
        }
        else {
            // do nothing
        }
    }, [location]);
    useEffect(function () {
        var hasCandidateIdFlag = location.pathname
            .toLowerCase()
            .includes("/sequent_backend_candidate/");
        if (location.pathname.split("/").length > 2 && hasCandidateIdFlag) {
            if (getCandidateIdFlag() === location.pathname.split("/")[2]) {
                refetchContestData();
                setTimeout(function () {
                    candidateTreeRefetch();
                }, 400);
            }
        }
    }, [getCandidateIdFlag, candidate_id]);
    var resultData = __assign({}, data);
    function changeArchiveSelection(val) {
        setArchivedElectionEvents(val === 1);
        resultData = {};
        navigate("/sequent_backend_election_event/");
    }
    var handleOpenCreateElectionEventMenu = function (e) {
        setAnchorEl(e.currentTarget);
    };
    var handleOpenCreateElectionEventForm = function (e) {
        setAnchorEl(null);
        openCreateDrawer === null || openCreateDrawer === void 0 ? void 0 : openCreateDrawer();
    };
    var handleOpenImportElectionEventForm = function (e) {
        setAnchorEl(null);
        openImportDrawer === null || openImportDrawer === void 0 ? void 0 : openImportDrawer();
    };
    var transformElectionEvent = function (electionEvent) {
        var _a;
        return __assign(__assign({}, electionEvent), { name: (_a = translateFromPresentation(electionEvent, "name", i18n.language)) !== null && _a !== void 0 ? _a : "-", alias: aliasRenderer(electionEvent) });
    };
    var transformElectionsForSort = function (elections) {
        return elections.map(function (election) {
            var _a, _b;
            return __assign(__assign({}, election), { tenant_id: tenantId || "", image_document_id: (_a = election.image_document_id) !== null && _a !== void 0 ? _a : "", contests: [], name: (_b = translateFromPresentation(election, "name", i18n.language)) !== null && _b !== void 0 ? _b : "-", alias: aliasRenderer(election) });
        });
    };
    var transformContestsForSort = function (contests) {
        return contests.map(function (contest) {
            var _a;
            return __assign(__assign({}, contest), { tenant_id: tenantId || "", candidates: [], max_votes: 0, min_votes: 0, winning_candidates_num: 0, is_encrypted: false, name: (_a = translateFromPresentation(contest, "name", i18n.language)) !== null && _a !== void 0 ? _a : "-", alias: aliasRenderer(contest) });
        });
    };
    var transformCandidatesForSort = function (candidates) {
        return candidates.map(function (candidate) {
            var _a;
            return __assign(__assign({}, candidate), { id: candidate.id, election_id: electionId || "", tenant_id: tenantId || "", name: (_a = translateFromPresentation(candidate, "name", i18n.language)) !== null && _a !== void 0 ? _a : "-", alias: aliasRenderer(candidate) });
        });
    };
    if (!loading && data && data.sequent_backend_election_event) {
        resultData = {
            electionEvents: __spreadArray([], ((_a = data.sequent_backend_election_event) !== null && _a !== void 0 ? _a : []), true),
        };
    }
    var finalResultData = useMemo(function () {
        var _a, _b;
        return {
            electionEvents: (_b = cloneDeep((_a = resultData === null || resultData === void 0 ? void 0 : resultData.electionEvents) !== null && _a !== void 0 ? _a : [])) === null || _b === void 0 ? void 0 : _b.map(function (electionEvent) {
                var _a, _b, _c;
                var electionOrderType = (_a = electionEvent === null || electionEvent === void 0 ? void 0 : electionEvent.presentation) === null || _a === void 0 ? void 0 : _a.elections_order;
                return __assign(__assign({}, transformElectionEvent(electionEvent)), (electionEvent.id === electionEventId
                    ? {
                        active: true,
                        elections: ((_c = (_b = sortElectionList(transformElectionsForSort((electionTreeData === null || electionTreeData === void 0 ? void 0 : electionTreeData.sequent_backend_election) || []), electionOrderType)) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 : _c.call(_b, function (e) {
                            var _a, _b, _c, _d;
                            var contestOrderType = (_a = e === null || e === void 0 ? void 0 : e.presentation) === null || _a === void 0 ? void 0 : _a.contests_order;
                            return __assign(__assign({}, e), (e.id === electionId
                                ? {
                                    active: true,
                                    contests: (_d = (_c = (_b = sortContestList(transformContestsForSort((contestTreeData === null || contestTreeData === void 0 ? void 0 : contestTreeData.sequent_backend_contest) ||
                                        []), contestOrderType)) === null || _b === void 0 ? void 0 : _b.map) === null || _c === void 0 ? void 0 : _c.call(_b, function (c) {
                                        var _a, _b, _c, _d, _e, _f;
                                        var orderType = (_a = c.presentation) === null || _a === void 0 ? void 0 : _a.candidates_order;
                                        return __assign(__assign({}, c), (c.id === contestId
                                            ? {
                                                active: true,
                                                candidates: (_d = (_c = (_b = sortCandidatesInContest(transformCandidatesForSort((candidateTreeData === null || candidateTreeData === void 0 ? void 0 : candidateTreeData.sequent_backend_candidate) ||
                                                    []), orderType)) === null || _b === void 0 ? void 0 : _b.map(function (ca) { return (__assign(__assign({}, ca), { active: ca.id ===
                                                        candidateId })); })) === null || _c === void 0 ? void 0 : _c.map(function (ca) { return (__assign(__assign({}, ca), { active: ca.id ===
                                                        candidateId })); })) !== null && _d !== void 0 ? _d : [],
                                            }
                                            : {
                                                active: false,
                                                candidates: (_f = (_e = sortCandidatesInContest(transformCandidatesForSort((candidateTreeData === null || candidateTreeData === void 0 ? void 0 : candidateTreeData.sequent_backend_candidate) ||
                                                    []), orderType)) === null || _e === void 0 ? void 0 : _e.map(function (ca) { return (__assign(__assign({}, ca), { active: false })); })) !== null && _f !== void 0 ? _f : [],
                                            }));
                                    })) !== null && _d !== void 0 ? _d : [],
                                }
                                : { active: false, contests: [] }));
                        })) || [],
                    }
                    : { active: false, elections: [] }));
            }),
        };
    }, [
        electionEventId,
        electionId,
        contestId,
        candidateId,
        electionTreeData,
        contestTreeData,
        candidateTreeData,
        data,
        searchInput,
    ]);
    finalResultData = filterTree(finalResultData, searchInput);
    var reloadTreeMenu = function () {
        candidateTreeRefetch();
        contestTreeRefetch();
        electionTreeRefetch();
        electionEventTreeRefetch();
        originalRefetch();
        navigate("/sequent_backend_election_event/");
    };
    var debouncedSearchChange = useMemo(function () {
        var debouncedFn = debounce(function (value) {
            console.log("edu: debounce: ".concat(value));
            // Expensive operation or API call
            setSearchInput(value);
        }, 300);
        return function (value) {
            // Update state immediately
            setInstantSearchInput(value);
            debouncedFn(value);
        };
    }, []);
    var treeMenu = loading ? (_jsx(CircularProgress, {})) : (_jsx(TreeMenu, { data: finalResultData, treeResourceNames: TREE_RESOURCE_NAMES, isArchivedElectionEvents: isArchivedElectionEvents, onArchiveElectionEventsSelect: changeArchiveSelection, reloadTree: reloadTreeMenu }));
    return (_jsxs(_Fragment, { children: [_jsxs(Container, { isActive: isElectionEventActive, children: [_jsxs(HorizontalBox, { sx: {
                            alignItems: "center",
                            paddingRight: i18n.dir(i18n.language) === "rtl" ? 0 : "16px",
                            paddingLeft: i18n.dir(i18n.language) === "rtl" ? "32px" : 0,
                        }, children: [_jsx(MenuItem, { to: "/sequent_backend_election_event", primaryText: isOpenSidebar && t("sideMenu.electionEvents"), leftIcon: _jsx(WebIcon, { sx: { color: adminTheme.palette.brandColor } }), sx: {
                                    flexGrow: 2,
                                    paddingLeft: i18n.dir(i18n.language) === "rtl" ? 0 : "16px",
                                    paddingRight: i18n.dir(i18n.language) === "rtl" ? "16px" : 0,
                                } }), isOpenSidebar && showAddElectionEvent ? (_jsx(StyledIconButton, { onClick: handleOpenCreateElectionEventMenu, className: "election-event-create-button", icon: faPlusCircle, size: "xs" })) : null] }), isOpenSidebar && (_jsxs(_Fragment, { children: [_jsxs(SideBarContainer, { dir: i18n.dir(i18n.language), children: [_jsx(TextField, { dir: i18n.dir(i18n.language), label: String(t("sideMenu.search")), size: "small", value: instantSearchInput, onChange: function (e) { return debouncedSearchChange(e.target.value); } }), _jsx(SearchIcon, {})] }), treeMenu] }))] }), _jsxs(MMenu, { id: "treemenu-create-election-event-menu", anchorEl: anchorEl, anchorOrigin: {
                    vertical: "bottom",
                    horizontal: "right",
                }, keepMounted: true, transformOrigin: {
                    vertical: "top",
                    horizontal: "left",
                }, open: Boolean(anchorEl), onClose: function () { return setAnchorEl(null); }, children: [_jsx(MMenuItem, { className: "menu-sidebar-item", onClick: handleOpenCreateElectionEventForm, children: _jsx(Box, { sx: {
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            }, children: _jsx("span", { className: "help-menu-item", title: "Create Election Event", children: t("createResource.electionEvent") }) }) }), _jsx(MMenuItem, { className: "menu-sidebar-item", onClick: handleOpenImportElectionEventForm, children: _jsx(Box, { sx: {
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                            }, children: _jsx("span", { className: "help-menu-item", title: "Import Election Event", children: t("electionEventScreen.import.eetitle") }) }) })] })] }));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
